import { Box, BoxProps, Skeleton } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import Link from "components/Shared/Link";
import { Url } from "utils/links";

const baseFragment = gql(/* GraphQL */ `
  fragment RetailerLocationGroupBaseNameFragment on RetailerLocationGroup {
    id
    name
  }
`);

const fragment = gql(/* GraphQL */ `
  fragment RetailerLocationGroupNameFragment on RetailerLocationGroup {
    id
    ...RetailerLocationGroupBaseNameFragment
    retailer {
      id
      nameWithUniqueSuffix
    }
  }
`);

type BaseProps = {
  isLoading?: boolean;
  location: FragmentType<typeof baseFragment> | null | undefined;
};

export function BaseLocationGroupName({ isLoading, location }: BaseProps) {
  const rlg = getFragmentData(baseFragment, location);

  const { name } = rlg || {};

  return (
    <Box noOfLines={2}>
      <Skeleton isLoaded={!!name || !isLoading} display="inline">
        {name || "                 "}
      </Skeleton>
    </Box>
  );
}

type Props = BoxProps & {
  getRetailerLink?: (retailerId: string) => Url | undefined;
  isLoading?: boolean;
  location: FragmentType<typeof fragment> | null | undefined;
};

export default function LocationGroupName({
  getRetailerLink,
  isLoading,
  location,
  ...rest
}: Props) {
  const rlg = getFragmentData(fragment, location);

  const r = rlg?.retailer;

  return (
    <Box
      display="inline-flex"
      flexFlow="column"
      maxW="100%"
      lineHeight="normal"
      {...rest}
    >
      <Box fontSize=".75em" fontWeight={500} isTruncated opacity={0.65}>
        <Skeleton
          isLoaded={!!r?.nameWithUniqueSuffix || !isLoading}
          display="inline"
        >
          <Link href={r ? getRetailerLink?.(r.id) : undefined}>
            {r?.nameWithUniqueSuffix || "                              "}
          </Link>
        </Skeleton>
      </Box>

      <BaseLocationGroupName isLoading={isLoading} location={rlg} />
    </Box>
  );
}
